<template>
  <!--发票信息编辑-->
  <div class="fapiao-edit" :visible.sync="editVisible">
    <el-form ref="faPiaoForm" :model="faPiaoForm" :rules="rules" label-width="160px">
      <el-form-item label="企业名称：" prop="cmpname">
        <el-input v-model="faPiaoForm.cmpname" placeholder="请输入企业名称"></el-input>
      </el-form-item>
      <el-form-item label="统一社会信用代码：" prop="buslicno">
        <el-input v-model="faPiaoForm.buslicno" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="营业执照注册地址：">
        <el-row :gutter="10">
          <el-col :span="7">
            <el-select filterable v-model="faPiaoForm.province" placeholder="请选择省" @change="getcitys(faPiaoForm.province,1)">
              <el-option v-for="item in provinces" :key="item.uuid" :label="item.name" :value="item.uuid"></el-option>
            </el-select>
          </el-col>
          <el-col :span="7">
            <el-select filterable v-model="faPiaoForm.city" placeholder="请选择市" @change="getareas(faPiaoForm.city,1)">
              <el-option v-for="item in citys" :key="item.uuid" :label="item.name" :value="item.uuid"></el-option>
            </el-select>
          </el-col>
          <el-col :span="7">
            <el-select filterable v-model="faPiaoForm.area" placeholder="请选择区">
              <el-option v-for="item in areas" :key="item.uuid" :label="item.name" :value="item.uuid"></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col style="margin-top: 15px; width: 80%">
            <el-input v-model="faPiaoForm.adress1" placeholder="请输入确切地址"></el-input>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="固定电话：" prop="sitcomp">
        <el-input v-model="faPiaoForm.sitcomp" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="对公账户开户行：" prop="bankinfo">
        <el-input v-model="faPiaoForm.bankinfo" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="对公账号：" prop="pubaccout">
        <el-input v-model="faPiaoForm.pubaccout" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="联系人：" prop="linman">
        <el-input v-model="faPiaoForm.linman" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="联系电话：" prop="linephone">
        <el-input v-model="faPiaoForm.linephone" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="通信地址：" prop="mailadd">
        <el-input v-model="faPiaoForm.mailadd" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="通信邮箱地址：" prop="invmailadd">
        <el-input v-model="faPiaoForm.invmailadd" placeholder=""></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="danger" @click="onSubmit">确定</el-button>
        <el-button @click="cancle">取消</el-button>
      </el-form-item>
    </el-form>
  </div>

</template>

<script>
import auth from '@/utils/auth'
import utils from '@/utils/utils'
import { GetCompany, EditCompany } from '@/api/company'
import { getChina } from '@/api/china'
export default {
  name: 'Order.vue',
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else {
        const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
        // console.log(reg.test(value))
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号'))
        }
      }
    }
    var checkemail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('邮箱不能为空'))
      } else {
        const reg = /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/
        // console.log(reg.test(value))
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的邮箱'))
        }
      }
    }
    var checkcode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('身份证号不能为空'))
      } else {
        const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
        // console.log(reg.test(value))
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的身份证'))
        }
      }
    }
    var validateTelphone = (rule, value, callback) => {
      if (!value) {
        callback()
      } else {
        const reg = /^(\d{3,4}-)?\d{7,8}$/
        // console.log(reg.test(value))
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的固话号码'))
        }
      }
    }
    var checkcode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('身份证号不能为空'))
      } else {
        const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
        // console.log(reg.test(value))
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的身份证'))
        }
      }
    }
    var checkSpecificKey = (rule, value, callback) => {
      if (!utils.checkSpecificKey1(value)) {
        callback(new Error('不支持特殊符号'))
      } else {
        callback()
      }
    }
    var checkCmpCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('营业执照注册号不能为空'))
      } else {
        if (value.length == 15 || value.length == 18) callback()
        else return callback(new Error('请输入正确的营业执照注册号'))
      }
    }
    var validatebankname = (rule, value, callback) => {
      var self = this
      if (value === '') {
        callback(new Error('请输入开户名称'))
      } else if (value !== self.zhuceForm.cmpname) {
        callback(new Error('开户名称与注册主体信息不一致!'))
      } else {
        callback()
      }
    }
    return {
      activeName: 'first',
      editVisible: false,
      faPiaoForm: {},
      provinces: [],
      citys: [],
      areas: [],
      compid: '',
      rules: {
        linephone: [
          {
            required: true,
            validator: checkPhone,
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            validator: checkemail,
            trigger: 'blur',
          },
        ],
        cmpname: [
          {
            required: true,
            validator: checkSpecificKey,
            trigger: 'blur',
          },
        ],
        buslicno: [
          {
            required: true,
            validator: checkCmpCode,
            trigger: 'blur',
          },
        ],
        cardno: [
          {
            required: true,
            validator: checkcode,
            trigger: 'blur',
          },
        ],
        sitcomp: [
          {
            validator: validateTelphone,
            trigger: 'blur',
          },
        ],

        invmailadd: [
          {
            required: true,
            validator: checkemail,
            trigger: 'blur',
          },
        ],
        depbankname: [
          {
            required: true,
            validator: validatebankname,
            trigger: 'blur',
          },
        ],
        bankinfo: [
          {
            required: true,
            message: '请输入详细开户行',
            trigger: 'blur',
          },
        ],
        pubaccout: [
          {
            required: true,
            message: '请输入对公账户',
            trigger: 'blur',
          },
        ],
        personname: [
          {
            required: true,
            message: '请输入法定代表人姓名',
            trigger: 'blur',
          },
        ],
        mailadd: [
          {
            required: true,
            message: '请输入发票收件地址',
            trigger: 'blur',
          },
        ],
        personname: [
          {
            required: true,
            message: '请输入法定代表人姓名',
            trigger: 'blur',
          },
        ],
        buslic: [
          {
            required: true,
            message: '请上传营业执照',
            trigger: 'blur',
          },
        ],
        bussType: [
          {
            required: true,
            message: '请选择企业类型',
            trigger: 'blur',
          },
        ],
        six: [
          {
            required: true,
            message: '请选择性别',
            trigger: 'blur',
          },
        ],
        linman: [
          {
            required: true,
            message: '请输入联系人',
            trigger: 'blur',
          },
        ],
        openlicup: [
          {
            required: true,
            message: '请上传开户许可证',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  created() {
    this.editVisible = false
    this.compid = auth.getcmpid()
    this.getprovinces()
    this.getData()
  },
  methods: {
    getprovinces() {
      getChina({ pid: 0 })
        .then((res) => {
          this.provinces = res.data
        })
        .catch((res) => {})
    },
    getcitys(province, id) {
      getChina({ pid: province })
        .then((res) => {
          this.citys = res.data
          if (id == 1) {
            this.faPiaoForm.city = this.citys.indexOf(0).id
            this.faPiaoForm.area = ''
          }
        })
        .catch((res) => {})
    },
    getareas(city, id) {
      getChina({ pid: city })
        .then((res) => {
          this.areas = res.data
          if (id == 1) {
            this.faPiaoForm.area = null
          }
        })
        .catch((res) => {})
    },
    // ---------------------------
    cancle() {
      //   this.$router.push('/Dashboard')
      location.reload()``
    },
    getData() {
      var self = this
      GetCompany({
        uuid: self.compid,
        sessionToken: auth.getToken(),
      })
        .then((res) => {
          if (res.data.province == undefined || res.data.province == null) {
            res.data.province = ''
          } else {
            res.data.province = res.data.province.toString()
          }

          if (res.data.city == undefined || res.data.city == null) {
            res.data.city = ''
          } else {
            res.data.city = res.data.city.toString()
          }

          if (res.data.area == undefined || res.data.area == null) {
            res.data.area = ''
          } else {
            res.data.area = res.data.area.toString()
          }
          //   console.log('返回结果：' + JSON.stringify(res.data))
          self.faPiaoForm = res.data
          this.getcitys(self.faPiaoForm.province, 2)
          this.getareas(self.faPiaoForm.city, 2)
        })
        .catch((res) => {
          // this.$message("请与管理员联系");
        })
    },

    onSubmit() {
      this.$refs['faPiaoForm'].validate((valid) => {
        if (valid) {
          if (
            this.faPiaoForm.province == null ||
            this.faPiaoForm.province == ''
          ) {
            this.$message('省份不能为空')
            return false
          }
          if (this.faPiaoForm.city == null || this.faPiaoForm.city == '') {
            this.$message('城市不能为空')
            return false
          }
          if (this.faPiaoForm.area == null || this.faPiaoForm.area == '') {
            this.$message('地区不能为空')
            return false
          }
          if (
            this.faPiaoForm.adress1 == null ||
            this.faPiaoForm.adress1 == ''
          ) {
            this.$message('地址不能为空')
            return false
          }
          // console.log('提交：' + JSON.stringify(this.faPiaoForm))
          EditCompany(this.faPiaoForm)
            .then((res) => {
              if (res.code === 20000) {
                location.reload()
              } else {
                this.$message(JSON.stringify(res.msg))
              }
            })
            .catch((res) => {
              this.$message(JSON.stringify(res))
            })
        }
      })
    },
  },
}
</script>

<style>
.fapiao-edit .el-form-item__label {
  display: inline-block;
  width: 150px;
  padding-right: 10px;
  text-align: right;
  color: #777;
}

.fapiao-edit {
  width: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/FaPiaoEdit.vue